export function focusInput(pattern, id) {
  const newDish = document.getElementById(`${pattern}-${id}`);
  const position = newDish.offsetTop;
  window.scrollTo(0, position - window.innerHeight / 2);
  document.getElementsByName(`${pattern}-${id}`)[0].focus();
}
